import { rem } from "polished";
import { css, styled } from "styled-components";

import { APP_GUTTER, APP_WIDTH } from "styles";
import { LG_WIDTH, MD_WIDTH } from "styles/theme/layout";

export const PaginationButton = styled.button`
  &:hover {
    --outline-color: ${({ theme }) => theme.colors.vividBlue};
  }
`;

export const SliderPagination = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  height: 48px;
`;

export const HomeSliderWrapper = styled.div`
  position: relative;
  overflow: hidden;
  width: 100vw;

  .right-arrow {
    color: ${({ theme }) => theme.colors.blue};
    margin-left: ${rem(16)};
    display: none;
  }

  &:hover .right-arrow {
    display: inline-block;
  }

  @media (min-width: ${APP_WIDTH}px) {
    max-width: ${APP_WIDTH}px;
  }
`;

export const SliderNavWrapper = styled.div`
  ${({ theme }) => theme.typography.bodyText["b3impact"]};
  @media (min-width: ${LG_WIDTH}px) {
    ${({ theme }) => theme.typography.bodyText["b1impact"]};
  }
`;

export const SliderWrapper = styled(HomeSliderWrapper)`
  width: calc(100vw - 48px);

  @media (min-width: ${LG_WIDTH}px) {
    width: calc(100vw - ${APP_GUTTER * 2}px);
  }

  @media (min-width: ${APP_WIDTH}px) {
    max-width: calc(${APP_WIDTH}px - ${APP_GUTTER * 2}px);
  }

  max-height: auto;
  .swiper-wrapper {
    margin-top: 70px;
  }
`;

export const HomeSlideWrapper = styled.div<{ $backgroundImage: string }>`
  position: relative;
  background-image: url(${({ $backgroundImage }) => $backgroundImage});
  background-size: cover;
  background-repeat: no-repeat;
`;

export const SlideProgress = styled.div`
  user-select: none;
  border-radius: 7px;
  background: #fff;
  width: 223px;
  height: 63px;
  box-shadow: 0px 4px 34px 0px rgba(0, 0, 0, 0.12);
  backdrop-filter: blur(37px);
  color: ${({ theme }) => theme.colors.lightSecondary};
  ${({ theme }) => theme.typography.bodyText["b6reg"]};
  font-weight: 400;
  text-transform: uppercase;
  padding: ${rem(17)} ${rem(14)};
  margin-right: ${rem(10)};
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  opacity: 0.5;
  transition: opacity 0.25s ease-in-out;
  cursor: pointer;

  &:hover {
    opacity: 0.75;
    color: ${({ theme }) => theme.colors.vividBlue};
  }
`;

export const ProgressBar = styled.progress`
  width: 100%;
  height: 2px;
  &[value] {
    -webkit-appearance: none;
    appearance: none;

    &::-webkit-progress-bar {
      background-color: ${({ theme }) => theme.colors.lightBorder};
    }
    &::-webkit-progress-value {
      background-color: ${({ theme }) => theme.colors.lightBorder};
    }
  }
`;

export const SlideTitle = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const progressStyles = css`
  opacity: 1;

  color: ${({ theme }) => theme.colors.vividBlue};
  progress {
    display: block;
    &[value] {
      &::-webkit-progress-bar {
        background-color: ${({ theme }) => theme.colors.lightBorder};
      }
      &::-webkit-progress-value {
        background-color: ${({ theme }) => theme.colors.vividBlue};
      }
    }
  }
`;

const hiddenSvg = css`
  opacity: 0;
  pointer-events: none;
`;

const visibleSvg = css`
  opacity: 1;
  pointer-events: all;
`;

export const SlideProgressContainer = styled.div`
  position: absolute;
  font-size: 50px;
  left: ${rem(32)};
  width: 100%;
  bottom: ${rem(20)};
  z-index: 10;
  display: none;

  @media (min-width: ${MD_WIDTH}px) {
    display: block;
  }

  @media (min-width: ${LG_WIDTH}px) {
    left: ${APP_GUTTER}px;
    bottom: ${rem(40)};
  }

  .current-1 {
    div:nth-child(1) svg {
      ${visibleSvg}
    }
    div:nth-child(2) svg {
      ${hiddenSvg}
    }
    div:nth-child(3) svg {
      ${hiddenSvg}
    }
  }

  .current-2 {
    div:nth-child(1) svg {
      ${hiddenSvg}
    }
    div:nth-child(2) svg {
      ${visibleSvg}
    }
    div:nth-child(3) svg {
      ${hiddenSvg}
    }
  }

  .current-3 {
    div:nth-child(1) svg {
      ${hiddenSvg}
    }
    div:nth-child(2) svg {
      ${hiddenSvg}
    }
    div:nth-child(3) svg {
      ${visibleSvg}
    }
  }

  .current-1 {
    div:nth-child(1) {
      ${progressStyles};
    }
  }
  .current-2 {
    div:nth-child(2) {
      ${progressStyles};
    }
  }
  .current-3 {
    div:nth-child(3) {
      ${progressStyles};
    }
  }
  & > div {
    display: flex;
  }
`;
